import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {CurrencyFormatter} from "../../../utils/formatters";
import Select from '../../form/Select';

// filter
// Mi a különbség a TextInput és a ComponentField között? a componentfield univerzális input mező szeretne lenni?

class ShippingFeeForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                <div className="col-sm-8 col-sm-8">
                        <Select
                            storeType="local"
                            label="Szolgáltató"
                            name="serviceprovider"
                            optionname="shippingprovider"
                            objectValue={false}
                            value={this.props.values.serviceprovider}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("shippingprovider")}
                        />
                    </div>
                    <div className="col-sm-4 col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue  == "" ? null : this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12 col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="fee"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue  == "" ? null : this.props.setFieldValue}
                            label="Költség"
                            formatter={CurrencyFormatter}
                            type="decimal"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="price_limit"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue  == "" ? null : this.props.setFieldValue}
                            label="Ár felső határa (HUF)"
                            formatter={CurrencyFormatter}
                            type="decimal"
                        />
                    </div>
                    <div className="col-sm-4 col-sm-4">
                    <ComponentField
                        getFieldProps={this.props.getFieldProps}
                        componentConfig={this.props.componentConfig}
                        name="weight_limit"
                        values={this.props.values}
                        setFieldValue={this.props.setFieldValue  == "" ? null : this.props.setFieldValue}
                        label="Súly felső határa (g)"
                        type="decimal"
                    />
                    </div>
                    <div className="col-sm-4 col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="size_limit"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue  == "" ? null : this.props.setFieldValue}
                            label={<>Méret felső határa (cm<sup>3</sup>)</>}
                            type="decimal"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(ShippingFeeForm);
